module.exports = {"id":"dp2_5l1q1","text":"Digital Behaviour","instructions":"Digital communication often lacks facial expression and body language.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.5","questionType":"PickOne","random":false,"options":[{"id":"dp2_5l1q1-a1","text":"True","score":1.8},{"id":"dp2_5l1q1-a2","text":"Not sure","score":0},{"id":"dp2_5l1q1-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.5/l1q1.json
// module id = 1067
// module chunks = 41